const KEYS = {
  MESSAGES: 'pl_ais_messages',
  DRAFT: 'pl_ais_draft',
  SESSION_ID: 'pl_ais_session_id',
  FONT_SIZE: 'pl_ais_font_size',
  USER_KEY: 'pl_ais_user_key',
};

export function loadMessages() {
  try {
    const raw = localStorage.getItem(KEYS.MESSAGES);
    if (!raw) {
      return [];
    }
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

export function saveMessages(immutableMessages) {
  try {
    localStorage.setItem(KEYS.MESSAGES, JSON.stringify(immutableMessages.toJS()));
  } catch (e) {
    console.warn('AI Streaming Assistant: failed to persist messages', e);
  }
}

export function clearMessages() {
  localStorage.removeItem(KEYS.MESSAGES);
}

export function loadDraft() {
  return localStorage.getItem(KEYS.DRAFT) || '';
}

export function saveDraft(text) {
  if (text) {
    localStorage.setItem(KEYS.DRAFT, text);
  } else {
    localStorage.removeItem(KEYS.DRAFT);
  }
}

function generateSessionId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function loadSessionId() {
  let sessionId = localStorage.getItem(KEYS.SESSION_ID);
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem(KEYS.SESSION_ID, sessionId);
  }
  return sessionId;
}


export function regenerateSessionId() {
  
  const sessionId = generateSessionId();
  
  localStorage.setItem(KEYS.SESSION_ID, sessionId);
  
  return sessionId;
}


export function loadFontSize() {
  const parsed = parseInt(localStorage.getItem(KEYS.FONT_SIZE), 10);
  return isNaN(parsed) ? null : parsed;
}

export function saveFontSize(size) {
  localStorage.setItem(KEYS.FONT_SIZE, String(size));
}


function saveUserOrgKey(key) {
  localStorage.setItem(KEYS.USER_KEY, key);
}



function generateUserOrgKey(userData) {
  return `${userData.username}|${userData.email}|${userData.userOrg?.id}|${userData.loggedInOrg?.name}`;
}


/**
 * Checks whether the logged-in user or org has changed since the last session.
 * If so, resets the chat session ID and clears persisted messages so a new
 * user/org starts with a clean slate.
 *
 * @param {{ username: string, email: string, userOrg: { id: string }, loggedInOrg: { name: string } }} userData
 */
export function checkAndResetIfUserChanged(userData) {
  const currentKey = generateUserOrgKey(userData);
  const storedKey = localStorage.getItem(KEYS.USER_KEY);

  if (storedKey !== currentKey) {
    clearMessages();
    regenerateSessionId();
    saveUserOrgKey(currentKey);
  }
}

